const styles = {
  wrapper: {
    margin: "90px 100px 70px",
    width: "80%",
    maxWidth: "1170px",
  },
  quickFacts: {
    wrapper: {
      display: "flex",
      marginBottom: "70px",
    },
    title: {
      flexBasis: "25%",
      marginRight: "100px",
      fontSize: "30px",
      "@media (max-width: 1200px)": {
        fontSize: "26px",
      },
    },
    content: {
      flexBasis: "75%",
      display: "flex",
      flexWrap: "wrap",
    },
    contentCard: {
      flexBasis: "33%",
      "@media (max-width: 940px)": {
        flexBasis: "25%",
      },
    },
  },
  consumers: {
    wrapper: {
      display: "flex",
      justifyContent: "flex-end",
    },
    content: {
      flexBasis: "50%",
      display: "flex",
      alignItems: "flex-start",
    },
    contentCard: {
      flexGrow: 1,
      margin: "0 24px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "@media (max-width: 1200px)": {
        fontSize: "26px",
        margin: "0 10px",
      },
    },
    title: {
      flexBasis: "25%",
      marginLeft: "100px",
      fontSize: "30px",
      "@media (max-width: 1200px)": {
        fontSize: "26px",
        marginLeft: "40px",
      },
    },
  },
};

export default styles;
